import { compose, defaultProps } from 'recompose';

import { svg, defaultWidgetConfig } from 'constants';

import CommonButton from './CommonButton';

export default compose(
  defaultProps({
    tooltipText: 'Chat',
    icon: svg.chat,
    customIconClass: 'chat-icon',
    widget: defaultWidgetConfig,
  }),
)(CommonButton);
